import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"];

  connect() {
    this.handleSubmitEnd = ({ detail: { success } }) => {
      if (success) this.close();
    };
    this.handleDialogClose = () => {
      this.dialogTarget.querySelector("form")?.reset();
    };
    this.dialogTarget.addEventListener("turbo:submit-end", this.handleSubmitEnd);
    this.dialogTarget.addEventListener("close", this.handleDialogClose);
  }

  disconnect() {
    this.dialogTarget.removeEventListener("turbo:submit-end", this.handleSubmitEnd);
    this.dialogTarget.removeEventListener("close", this.handleDialogClose);
  }

  open() {
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }
}
